import { PageHeader } from "../components/common/PageHeader";
import { UploadLimitBanner } from "../components/common/UploadLimitBanner";
import { ProjectScopeBanner } from "../components/common/ProjectScopeBanner";
import { OpsWizard } from "../components/common/OpsWizard";

export default function BulkDelete() {
  return (
    <div>
      <PageHeader title="Material Bulk Delete" subtitle="Soft-delete (archive) GRN_PENDING materials only — history is always retained" />
      <UploadLimitBanner kind="delete" />
      <ProjectScopeBanner requireProject action="bulk delete" />
      <OpsWizard
        testid="delete"
        needsType
        templateUrl="/materials/delete/template"
        previewUrl="/materials/delete/preview"
        applyUrl="/materials/delete/apply"
        rejectedUrlBase="/materials/backlog/rejected"
        requireConfirm
        dangerTone
        confirmText="I understand these GRN_PENDING materials will be archived (removed from active use)."
        applyLabel={(n) => `Archive ${n} materials`}
        extraNote="Only GRN_PENDING materials are eligible. Deletion is a reversible-safe soft delete: full history is preserved for audit."
      />
    </div>
  );
}
